var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.885 11.116l-10.001-10c-0.011-0.011-0.027-0.015-0.039-0.026-0.104-0.1-0.225-0.183-0.359-0.243l-0.008-0.003-0.004-0c-0.129-0.050-0.279-0.079-0.435-0.079-0.072 0-0.143 0.006-0.213 0.018l0.007-0.001c-0.056 0.007-0.106 0.017-0.154 0.030l0.008-0.002c-0.224 0.051-0.418 0.158-0.573 0.306l0.001-0-10 10c-0.224 0.226-0.363 0.537-0.363 0.881 0 0.69 0.56 1.25 1.25 1.25 0.344 0 0.655-0.139 0.881-0.363l7.866-7.866v24.982c0 0.69 0.56 1.25 1.25 1.25s1.25-0.56 1.25-1.25v0-24.982l7.865 7.866c0.226 0.227 0.539 0.367 0.885 0.367 0.691 0 1.251-0.56 1.251-1.251 0-0.345-0.14-0.658-0.366-0.884v0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.c709c830a7e76ef5b48b66f611b8bb26.svg";
export { ForwardRef as ReactComponent };